<template>
  <div class="content">
    <el-button size="small" @click="accountDetails" class="skClsaa">
      收款账号详情
      <i class="el-icon-s-operation"></i>
    </el-button>
    <div class="table" style="margin-top: 10px;">
       <el-table :data="tableData" border :span-method="cellMerge">
         <el-table-column prop="name" label="公众号名称" align="center"></el-table-column>
         <el-table-column prop="money" label="今日收款金额" align="center"></el-table-column>
         <el-table-column prop="monthMoney" label="当月收款金额" align="center"></el-table-column>
         <el-table-column prop="maxMoney" label="日最大收款金额" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.editShow">{{scope.row.maxMoney}}</span>
              <el-input v-if="!scope.row.editShow" v-model="scope.row.maxMoney" placeholder="请输入日最大收款金额"></el-input>
            </template>
         </el-table-column>
         <el-table-column prop="monthMaxMoney" label="月最大收款金额" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.editShow">{{scope.row.monthMaxMoney}}</span>
              <el-input v-if="!scope.row.editShow" v-model="scope.row.monthMaxMoney" placeholder="请输入月最大收款金额"></el-input>
            </template>
         </el-table-column>
         <el-table-column prop="effect" label="当前收款账号" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.effect"
                active-color="#13ce66"
                inactive-color="#DCDFE6"
                active-value="1"
                inactive-value="0"
                @change="alonerenewChange(scope.row)"
              ></el-switch>
            </template>
         </el-table-column>
         <el-table-column prop="priority" label="优先级" align="center">
           <template slot-scope="scope">
             <span v-if="scope.row.editShow">{{scope.row.priority}}</span>
             <el-input v-if="!scope.row.editShow" v-model="scope.row.priority" placeholder="请输入优先级"></el-input>
           </template>
         </el-table-column>
         <el-table-column prop="shortName" label="收款商户名称" align="center"></el-table-column>
         <el-table-column prop="mchId" label="收款商户号" align="center"></el-table-column>
         <el-table-column prop="mchName" label="商户主体" align="center" width="260px"></el-table-column>
         <el-table-column prop="status" label="状态" :formatter="status" align="center"></el-table-column>
         <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain icon="el-icon-edit"  @click="editRow(scope.row)" v-if="scope.row.editShow">编辑</el-button>
              <el-button size="mini" type="success" plain icon="el-icon-edit" @click="preservation(scope.row)" v-if="!scope.row.editShow" >保存</el-button>
            </template>
         </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { dictionaryPayList } from "@/api/api.js";
import { dictionaryPayUpdate } from "@/api/api.js";
export default {
  data() {
    return{
      tableData:[],
      rowIndex: '-1',
      OrderIndexArr: [],
      spanArr:[],
      pos:0
    }
  },
  methods: {
    // 收款账号详情
    accountDetails(){
      this.$router.push('/user/payAccountList')
    },
    // 获取列表的数据
    initData(){
      dictionaryPayList({}).then(res=>{
        if (res.data.code == 200) {
          res.data.data.map(item=>{
            item.editShow = true;
          })
          this.tableData = res.data.data;
          // 等待 DOM 同步后计算合并规则
          this.$nextTick(() => {
            this.getSpanArr(this.tableData);
          });
        }
      })
    },
    // 编辑
    editRow(row){
      this.tableData.map((item)=>{
        item.editShow = true;
      })
      row.editShow = false;
    },
    // 保存
    preservation(row){
      let params = {
        id:row.id,
        monthMaxMoney:row.monthMaxMoney,
        maxMoney:row.maxMoney,
        priority:row.priority
      }
      dictionaryPayUpdate(params).then(res=>{
        if (res.data.code == 200) {
          this.initData();
          // row.editShow = true
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 设置状态
    alonerenewChange(row){
      let params = {
        id:row.id,
        effect:row.effect
      }
      dictionaryPayUpdate(params).then(res=>{
        if (res.data.code == 200) {
          this.$message.success("状态更新成功");
          this.initData();
        }else{
          this.$message.error(res.data.message);
          // 回滚开关状态
          row.effect = row.effect === "1" ? "0" : "1";
          // this.initData();
        }
      })
    },
    // 获取相同编号的数组
    getOrderNumber() {
      let OrderObj = {}
      this.tableData.forEach((element, index) => {
        element.rowIndex = index
        if (OrderObj[element.name]) {
          OrderObj[element.name].push(index)
        } else {
          OrderObj[element.name] = []
          OrderObj[element.name].push(index)
        }
      });
      // 将数组长度大于1的值 存储到this.OrderIndexArr（也就是需要合并的项）
      for (let k in OrderObj){
        if (OrderObj[k].length > 1) {
          this.OrderIndexArr.push(OrderObj[k]);
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        for (let i = 0; i < this.OrderIndexArr.length; i++) {
          let element = this.OrderIndexArr[i];
          for (let j = 0; j < element.length; j++) {
            let item = element[j]
            if (rowIndex == item) {
              if (j == 0) {
                return {
                  rowspan: element.length,
                  colspan: 1
                }
              }else{
                return {
                  rowspan :0,
                  colspan :0
                }
              }
            }
          }
        }
      }
    },
    getSpanArr(data) {　
      this.spanArr = [];
      this.pos = 0;
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          // this.pos = 0
        } else {
        // 判断当前元素与上一个元素是否相同
          if (data[i].name === data[i - 1].name) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    status(row){
        return row.status=='1' ? '启用' : '停用';
    }
  },
  created() {
    this.initData()
  },
  mounted() {},
};
</script>
<style scoped lang="less">
  .skClsaa{
    cursor: pointer;
    // float: right;
    margin-bottom: 5px;
  }
  .skClsaa:hover{
    color: #007ACC;
  }
  /deep/ .el-input__inner{
    width: 80%;
    height: 35px;
    line-height: 35px;
  }
  /deep/ .el-table--enable-row-transition .el-table__body td{
    height: 65px;
  }
</style>


